import unitUtil from '../utils/unit.util'
import { Markup } from '../views/LabelBuilder/LabelBuilder.slice'

const labelStageService = {
  scaleImageToStage (stage: Markup['stage'], image: HTMLImageElement) {
    const stageWidth = unitUtil.unitToPixel(stage.unit, stage.width)
    const stageHeight = unitUtil.unitToPixel(stage.unit, stage.height)
    const isWidthScale = image.width > image.height
    const isExceedStage = image.width > stageWidth || image.height > stageHeight
    if (!isExceedStage) return image
    const scaledImageWidth = isWidthScale
      ? stageWidth
      : (stageHeight / image.height) * image.width
    const scaledImageHeight = isWidthScale
      ? (stageWidth / image.width) * image.height
      : stageHeight
    image.width = (scaledImageWidth - 20)
    image.height = (scaledImageHeight - 20)
    return image
  }
}

export default labelStageService
